import useFetch from '../Hooks/useFetch';

const getCategories = () => {
  const { state: products }: any = useFetch(`${process.env.REACT_APP_BASE_URL}/products/categories`);
  return products;
};
export default getCategories;
